export var tryCatch = function (tryFunc, catchFunc) {
    try {
        return tryFunc();
    }
    catch (error) {
        return catchFunc(error);
    }
};
